import { GetApp } from "../../App"
import { Block, BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { Icon, Icons } from "../../Components/Icon"
import { GetAppView } from "../AppView"
import { AppOverlayContent } from "../AppOverlayContentView"
import { AccountSettingsEditAccount } from "./Context"
import { AccountSettingsAccountViewProps } from "./Params"

export function AccountSettingsAccountView({
  editAccount,
  setEditAccount,
  editAccountError,
  editAccountAction,
  saveAccountUser,
  showPassword,
  setShowPassword,
  accountDeletable,
}: AccountSettingsAccountViewProps) {
  const app = GetApp();
  const { setAppOverlay } = GetAppView();
  const t = app.getT("AccountSettingsView");

  const user = app.user || { accountId: undefined, email: "", name: "", shortname: "" };
  const account = app.account;

  return (
    <Block className="account-data-block">
      {editAccountError && (
        <BlockRow>
          <BlockField>
            <div className="error">{t(`error_${editAccountError}`)}</div>
          </BlockField>
        </BlockRow>
      )}
      <EditGroup editableFields={editAccount == AccountSettingsEditAccount.password ? ["oldPassword", "password", "passwordConfirmation"] : ["accountName", "name", "shortname"]} onSave={saveAccountUser}>
        <BlockRow className="account-settings-action-buttons">
          <BlockField>
            {editAccount == AccountSettingsEditAccount.none && (
              <>
                <button className="button" onClick={() => editAccountAction()}>
                  {t("edit_account")}
                </button>
              </>
            )}
          </BlockField>
          {editAccount == AccountSettingsEditAccount.none && app.cloudSession() && (
            <BlockField>
              <button className="button" onClick={() => setEditAccount(AccountSettingsEditAccount.password)}>
                {t("change_password")}
              </button>
            </BlockField>
          )}
          {app.cloudSession() && accountDeletable && editAccount == AccountSettingsEditAccount.none && (
            <BlockField>
              <button className="button" onClick={() => setAppOverlay(AppOverlayContent.removeAccount)}>
                {t("remove_account")}
              </button>
            </BlockField>
          )}
        </BlockRow>
        <BlockRow>
          <h3>{t(editAccount != AccountSettingsEditAccount.password ? "account_data" : "change_password")}</h3>
        </BlockRow>

        {editAccount != AccountSettingsEditAccount.password ? (
          <div key="account_data" className="account_data_row">
            {account && (
              <BlockRow>
                <BlockField label={t("account_name")} className="block_field_small_30">
                  <input defaultValue={account.name} name="accountName" readOnly={!editAccount} />
                </BlockField>
              </BlockRow>
            )}

            <BlockRow>
              <BlockField label={t("account_login")} className="block_field_small_30">
                <BlockFieldInputs>
                  <input defaultValue={user.email} name="login" readOnly={true} />
                </BlockFieldInputs>
              </BlockField>
            </BlockRow>

            <BlockRow>
              <BlockField label={t("customer_name")} className="block_field_small_30">
                <input defaultValue={user.name} name="name" readOnly={!editAccount} />
              </BlockField>
            </BlockRow>

            <BlockRow>
              <BlockField label={t("user_shortname")} className="block_field_small_16">
                <input defaultValue={user.shortname} name="shortname" readOnly={!editAccount} maxLength={10} />
              </BlockField>
            </BlockRow>
          </div>
        ) : (
          <div key="password_change">
            {/* Hidden mirror of the logged-in email: a password manager needs a username
                to know *which* stored credential this change-password form updates. It
                is not in EditGroup's `editableFields` above, so it is never submitted. */}
            <input type="text" name="username" autoComplete="username" value={user.email} readOnly hidden />

            <BlockRow>
              <BlockField label={t("current_password")} className="block_field_small_30">
                <input name="oldPassword" type="password" autoComplete="current-password" required />
              </BlockField>
            </BlockRow>

            <BlockRow>
              <BlockField label={t("new_password")} className="block_field_small_30">
                <span className="password-field">
                  <input name="password" type={showPassword ? "text" : "password"} autoComplete="new-password" required />
                  <Icon icon={showPassword ? Icons.EyeOn : Icons.EyeOff} className="password-toggle" onClick={() => setShowPassword(!showPassword)} />
                </span>
              </BlockField>
            </BlockRow>

            <BlockRow>
              <BlockField label={t("confirm_new_password")} className="block_field_small_30">
                <input name="passwordConfirmation" type="password" autoComplete="new-password" required />
              </BlockField>
            </BlockRow>
          </div>
        )}

        {editAccount != AccountSettingsEditAccount.none && (
          <BlockRow actions={true}>
            <BlockField>
              <button className="button" onClick={() => setEditAccount(AccountSettingsEditAccount.none)}>
                {t("account_edit_cancel")}
              </button>
            </BlockField>
            <BlockField>
              <button type="submit" className="button default">
                {t("account_edit_save")}
              </button>
            </BlockField>
          </BlockRow>
        )}
      </EditGroup>
    </Block>
  );
}
